import cta from './Cta';

export const menu = `
  name
  ctas {
    ${cta}
  }`;

export default menu;
